import s from '../ui/attach-file-modal/attach-file-modal.module.scss';
import { getFileTypeIcon } from '@utils/lib/fileTypesIcons';

const CATEGORY_BY_EXTENSION = {
	// Изображения
	image: ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'ico', 'tiff'],
	// Аудио
	audio: ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a', 'opus'],
	// Видео
	video: ['mp4', 'mov', 'avi', 'mkv', 'webm', 'm4v', 'wmv'],
	// PDF
	pdf: ['pdf'],
	// Текстовые документы
	doc: ['doc', 'docx', 'txt', 'rtf', 'md', 'pages', 'odt'],
	// Таблицы
	table: ['xls', 'xlsx', 'csv', 'numbers', 'ods'],
	// Презентации
	presentation: ['ppt', 'pptx', 'key', 'odp'],
	// Архивы
	archive: ['zip', 'rar', '7z', 'tar', 'gz'],
	// Код и разметка
	code: ['js', 'ts', 'jsx', 'tsx', 'css', 'scss', 'html', 'xml', 'php', 'sql', 'vue', 'rs', 'py', 'java', 'c', 'cpp', 'json', 'yml', 'yaml'],
};

export const FILE_TYPE_COLORS = {
	image: '#16A34A',
	audio: '#8B5CF6',
	video: '#3B82F6',
	pdf: '#F04438',
	doc: '#2563EB',
	table: '#179F25',
	presentation: '#F87728',
	archive: '#F59E0B',
	code: '#64748B',
	default: '#A7AEB8',
};

export const getFileTypeCategory = (extension) => {
	const ext = String(extension || '').replace(/^\./, '').toLowerCase();
	const category = Object.keys(CATEGORY_BY_EXTENSION).find((key) =>
		CATEGORY_BY_EXTENSION[key].includes(ext)
	);
	return category || 'default';
};

export const getFileTypeColor = (extension) =>
	FILE_TYPE_COLORS[getFileTypeCategory(extension)];

/** Приглушённый фон подложки — основной цвет категории с прозрачностью ~8%. */
export const getFileTypeMutedColor = (extension) => `${getFileTypeColor(extension)}14`;

/**
 * Иконка типа файла в фирменном цвете категории (tabler-иконки наследуют
 * currentColor) на подложке в приглушённом оттенке этого же цвета.
 */
export const FileTypeIcon = ({ extension, iconSize = 28 }) => {
	const color = getFileTypeColor(extension);

	return (
		<span className={s.typeThumb} style={{ background: getFileTypeMutedColor(extension) }}>
			<span className={s.typeIcon} style={{ color, width: iconSize, height: iconSize }}>
				{getFileTypeIcon(extension)}
			</span>
		</span>
	);
};
